<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow" v-loading="updateloading">

      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
              <el-input placeholder="客户名称 / 客户编码 / 组织码" v-model="query.key" @keyup.enter.native="getlists"  @change="ischange=true" clearable></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" circle @click="getlists"></el-button>
              <!--
              <el-tooltip class="item" effect="dark" content="点击同步更新金蝶的公司组织客户信息" placement="top">
                  <el-button type="danger" icon="el-icon-setting" circle @click="updatecustomers"></el-button>
              </el-tooltip>
              -->
              <el-button type="danger" icon="el-icon-plus" circle  @click="addcustomersinfos"></el-button>
          </el-form-item>
      </el-form>

      <el-tag type="danger" size="small" style="margin-top:10px">警告：因金蝶软件或系统信息在修改数据时不会主动同步至另一方，如其中一方有相应的数据发生修改时，请手动同步至另一方，否则将影响同步销售订单或者采购订单的数据同步</el-tag>


      <!-- 数据信息列表 -->
      <div class="backborder2" style="margin-top:10px">
      <el-table :data="customers" ref="multipleTable" style="width:100%;margin-top:10px" v-loading="loading" tooltip-effect="dark">
          <el-table-column label="id" prop="id" width="90"/>
          <el-table-column label="金蝶客户名称" prop="name" />
          <el-table-column label="是否已绑定宠赞客户" prop="ismatch" align="center" width="170"/>
          <el-table-column label="金蝶客户编码" prop="code" align="center" width="120"/>
          <el-table-column label="所属金蝶组织码" prop="orgnzcode" align="center" width="120"/>
          <el-table-column label="操作" align="center" width="120">
		      <template slot-scope="scope">
                  <el-button type="primary" icon="el-icon-edit" size="mini" circle  @click="getkingdeegoods(scope.row)"></el-button>
				  <el-button type="warning" icon="el-icon-edit" size="mini" circle  @click="editorder(scope.row)"></el-button>
			  </template>
		  </el-table-column>
      </el-table>
      <div class="block">
	      <!--分页begin-->
	      <el-pagination
		        @size-change="pageSizeChange"
		        @current-change="pageCurrentChange"
		        :current-page="query.p"
		        :page-sizes="[10, 20, 50]"
		        :page-size="query.rollpage"
		        layout="total, sizes, prev, pager, next, jumper"
		        :total="total_rows">
	      </el-pagination>
	      <!--分页end-->
	    </div>
      </div>

      <!-- 编辑关联客户信息 -->
      <el-dialog title="设置匹配客户信息" :visible.sync="settingDialog" width="35%" top="10vh">
          <el-form :inline="true" class="demo-form-inline" size="small">
            <el-form-item>
              <el-select v-model="settingquery.customername" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" @change="changesellcustomer">
                  <el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
              </el-select> 
            </el-form-item>
          </el-form>
          <div class="pd-goods-show" v-for="(item,index) in settingquery.customers" style="margin-top:10px">
            <div class="pd-goods-show-wl">{{item.name}}</div>
            <el-button type="danger" size="mini" circle icon="el-icon-delete" @click="delselectgoods(index)"></el-button>
          </div>	
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="settingDialog = false" style="margin-top:20px">取 消</el-button>
              <el-button size="small" type="danger" @click="savematchcustomer" style="margin-top:20px">确定</el-button>
          </div>    
      </el-dialog>

      <!-- 新增 / 编辑金蝶客户信息 -->
      <el-dialog title="新增金蝶客户信息" :visible.sync="addcustomersDialog" width="30%" top="10vh">
          <el-form :inline="true" class="demo-form-inline" size="small">
              <el-form-item label="金蝶客户名称" label-width="120">
                  <el-input placeholder="请输入金蝶客户名称" v-model="addcustomers.name" clearable></el-input>
              </el-form-item>
              <el-form-item label="金蝶客户编码" label-width="120">
                  <el-input placeholder="请输入金蝶客户编码" v-model="addcustomers.code" clearable></el-input>
              </el-form-item>
              <!--
              <el-form-item label="金蝶客户所属组织码" label-width="140">
                  <el-input placeholder="请输入客户组织码" v-model="addcustomers.orgnzcode" clearable></el-input>
              </el-form-item>
              -->
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="addcustomersDialog = false" style="margin-top:20px">取 消</el-button>
              <el-button size="small" type="danger" @click="saveaddcustomer" style="margin-top:20px">确定</el-button>
          </div> 
      </el-dialog>


  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Kingdee/index",
      transitionshow:true,
      actionauth:'',
      warns:true,
      querychange:false,
      query: {
        act:'getcustomerlists',
        token:this.$cookies.get('token'),
        key:'',
        p:1,
        rollpage:10
      },
      rows:0,
      loading:false,
      ischange:false,
      total_rows:0,
      customers:[],
      updateloading:false,
      settingDialog:false,
      settingquery: {
        act:'updatecustomercontact',
        token:this.$cookies.get('token'),
        id:'',
        customerid:'',
        customername:'',
        customers:[],
      },
      customerLists:[],
      customerLoading:false,
      addcustomers: {
        act:'addkingdeecustomers',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
        code:'',
        orgnzcode:'',
      },
      addcustomersDialog:false,

    }
  },

  mounted(){  
  	this.getactionauth(); //获取权限设置
    this.getlists(); //获取客户信息
  },

  methods: {

    /** 获取操作功能权限 **/
  	getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 更新客户信息 **/
    updatecustomers() {
      this.updateloading=true;
      var resource = this.$resource(this.url);
      resource.query({ act:'updatecustomers',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.updateloading=false;
          }else{
              this.updateloading=false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.updateloading=false;
      }); 
    },

    /** 获取金蝶客户信息列表 **/
    getlists() {
      this.loading=true;
      this.customers=[];
      if(this.ischange==true) {
        this.query.p=1;
        this.query.rollpage=10;
      }

      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.loading=false;
          }else{
              this.customers = JSON.parse(Base64.decode(res.data.Data));
              this.total_rows=parseInt(res.data.count);
              this.loading=false;
              if(this.ischange==true) this.ischange=false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.loading=false;
      }); 
    },

    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getlists();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getlists();
    },

    /** 获取绑定的客户信息 **/
    editorder(item) {
      this.settingquery.id=item.id;
      this.settingDialog=true;
      var resource = this.$resource(this.url);
      resource.query({ act:'getcustomercontact',id:item.id,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.settingquery.customerid='';
              this.settingquery.customername='';
              this.settingquery.customers=result;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      }); 
    },

    /** 获取客户 **/
	  getCustomer(query){
	      if (query !== '') {
		        this.customerLoading = true;
		        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
		        resource.query({act:'lists',key:query,token:this.$cookies.get('token'),p:1,rollpage:10000000}).then((res) => {
		            if(res.data.Result>0){
			            if(res.data.Result=='70001') this.$router.push('/login')
			            this.$message.error(res.data.Message);
			            this.customerLoading = false;
		            }else{
			            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
			            this.customerLoading = false;
		            }
		        }).catch((res) => {
		            //this.$message.error(this.GLOBAL.errortext);
		            this.customerLoading = false;
		        });
	      }
	  },

    /** 修改客户名称 **/
	  changesellcustomer(val) {
        var _this=this;
        var id=val;
        var name='';
        var isadd=false;
        this.customerLists.forEach(function(item,i) {if(id==item.id) name=item.name});
        this.settingquery.customers.forEach(function(item,i) {item.id==id ? isadd=true : ''});
        if(!isadd && id > 0) this.settingquery.customers.push({id:id,name:name});
	  },

    /** 保存绑定的客户信息 **/
    savematchcustomer() {
        var resource = this.$resource(this.url);
		    resource.save(this.settingquery).then((res) => {
		        if(res.data.Result>0){
			          if(res.data.Result=='70001') this.$router.push('/login')
			          this.$message.error(res.data.Message);
		        }else{
			          this.getlists();
                this.settingDialog=false;
		        }
		    }).catch((res) => {
		        //this.$message.error(this.GLOBAL.errortext);
		    });
    },


    /** 新增金蝶客户信息 **/
    addcustomersinfos() {
        this.addcustomers.act='addkingdeecustomers';
        this.addcustomers.id='';
        this.addcustomers.name=''; 
        this.addcustomers.code='';
        this.addcustomers.orgnzcode='';
        this.addcustomersDialog=true;
    },


    /** 获取金蝶客户信息 **/
    getkingdeegoods(item) {
        this.addcustomers.act='editkingdeecustomer';
        this.addcustomers.id=item.id;
        this.addcustomers.name=item.name; 
        this.addcustomers.code=item.code;
        this.addcustomers.orgnzcode='';
        this.addcustomersDialog=true;
    },


    /** 保存金蝶客户信息 **/
    saveaddcustomer() {
        var resource = this.$resource(this.url);
		resource.save(this.addcustomers).then((res) => {
		    if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
		    }else{
			    this.getlists();
                this.addcustomersDialog=false;
		    }
		}).catch((res) => {
		    //this.$message.error(this.GLOBAL.errortext);
		});
    },

    /** 删除已选中的客户信息 **/
    delselectgoods(index) {
        this.$delete(this.settingquery.customers,index);
    },


  },

  components:{
    
  }
}
</script>
<style>
.customerkingdee,.customercz {float:left;width:100%}
.customerkingdee,.customercz {float:left;width:100%}
.customerkingdee p,.customercz p {float:left;width:100%;font-size:14px;line-height:14px}
.customerkingdee .number,.customerkingdee .compny,.customercz .number,.customercz .compny {float:left;width:100%;margin-bottom:10px}
.customerkingdee .number i,.customercz .number i  {float:left;font-style:normal;margin-right:5px;font-size:12px;color:#fff;line-height:12px;padding:3px;border-radius:5px;background:#409EFF}
.customerkingdee .number span,.customercz .number span {float:left;font-size:12px;color:#666666;line-height:12px;margin-top:2px}
.customerkingdee .compny i,.customercz .compny i  {float:left;font-style:normal;margin-right:5px;font-size:12px;color:#fff;line-height:12px;padding:3px;border-radius:5px;background:#67C23A}
.customerkingdee .compny span,.customercz .compny span {float:left;font-size:12px;color:#666666;line-height:12px;margin-top:2px}
.pd-goods-show {float:left;width:96%;background:rgb(221,221,221);border-radius:5px;padding:10px 2%}
.pd-goods-show-wl {float:left;width:85%;color:red;font-size:12px;line-height:20px;}
.pd-goods-show .el-button--mini.is-circle {margin:0 0 0 5%}
</style>


// WEBPACK FOOTER //
// src/components/kingdee/KDcustomer.vue